function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shapes--inject-159"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 53.73,
    y1: 57.67,
    x2: 67.69,
    y2: 71.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.69,
    y1: 57.67,
    x2: 53.73,
    y2: 71.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.35,
    y1: 424.4,
    x2: 461.31,
    y2: 438.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.31,
    y1: 424.4,
    x2: 447.35,
    y2: 438.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.88,
    y1: 131.6,
    x2: 148.37,
    y2: 141.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.37,
    y1: 131.6,
    x2: 138.88,
    y2: 141.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.53,
    y1: 357.92,
    x2: 390.02,
    y2: 367.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.02,
    y1: 357.92,
    x2: 380.53,
    y2: 367.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.48,
    y1: 444.56,
    x2: 100.97,
    y2: 454.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.97,
    y1: 444.56,
    x2: 91.48,
    y2: 454.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.54,
    y1: 30.77,
    x2: 387.04,
    y2: 40.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.04,
    y1: 30.77,
    x2: 377.54,
    y2: 40.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.85,112.93a6,6,0,1,0-6,6A6,6,0,0,0,68.85,112.93Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.55,33.76a6,6,0,1,0-6,6A6,6,0,0,0,261.55,33.76Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.54,
    cy: 364.64,
    r: 5.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22,472.19a6,6,0,1,0-6,6A6,6,0,0,0,221.22,472.19Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.35,316.84a6,6,0,1,0-6,6A6,6,0,0,0,129.35,316.84Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.63,135.34a6,6,0,1,0-6,6A6,6,0,0,0,485.63,135.34Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-159"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 492.47,
    y1: 235.16,
    x2: 7.46,
    y2: 235.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.28,292.92l2.63,23.91c0,7,11.79,12.72,26.33,12.72s26.32-5.69,26.32-12.72l2.64-23.91Z",
    style: {
      fill: "#babdbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.39,278.78v14.74c0,3.77,13.81,8.46,30.85,8.46s30.85-4.69,30.85-8.46V278.78Z",
    style: {
      fill: "#babdbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.24,
    cy: 278.78,
    rx: 30.85,
    ry: 8.74,
    style: {
      fill: "#babdbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.24,
    cy: 278.78,
    rx: 24.04,
    ry: 6.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25,193.46c2.85.78,9.4-.32,9.41-.32s-2-4.1-2.2-4.34c-1.88-2.81-7.16-7.12-10.8-6.08a4.46,4.46,0,0,0-2.75,6.06C17.9,191.26,20.81,192.79,23.25,193.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.91,185.27c.06,0,.56-4.54.56-4.84,0-3.37-2-9.89-5.65-11A4.49,4.49,0,0,0,79.18,173c-.54,2.61,1,5.49,2.71,7.39C83.84,182.57,89.91,185.26,89.91,185.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.07,158.61c-3.78.14-7.46,5.88-8.38,9.13-.08.29-.81,4.82-.75,4.81H97c-.58.9-1.21,1.87-1.86,3-1.2,2-2.53,4.27-3.82,6.84a79.43,79.43,0,0,0-3.75,8.48,58.67,58.67,0,0,0-2.81,10,.57.57,0,0,0,0,.13c-.14-1.1-.64-4.16-.7-4.39-.91-3.26-4.58-9-8.36-9.15a4.48,4.48,0,0,0-4.51,4.91c.17,2.66,2.46,5,4.56,6.41,2.38,1.57,8.47,2.55,8.95,2.62a80,80,0,0,0-1,10.53q-.09,3.07,0,6.2c-.15-.95-.3-1.79-.33-1.91-.91-3.25-4.58-9-8.36-9.15a4.49,4.49,0,0,0-4.51,4.91c.17,2.66,2.46,5,4.57,6.42s7.31,2.34,8.68,2.57c0,.8,0,1.59,0,2.39.09,3.82.2,7.63.2,11.38,0,1.32,0,2.62-.1,3.92-.13-.84-.25-1.55-.28-1.66-.91-3.25-4.58-9-8.36-9.15a4.48,4.48,0,0,0-4.51,4.91c.17,2.67,2.46,5,4.56,6.42s6.81,2.25,8.44,2.53c-.08,1.33-.17,2.66-.31,4-.12.87-.17,1.72-.34,2.6s-.29,1.72-.44,2.57c-.33,1.63-.67,3.31-1,4.89-.25,1.1-.51,2.14-.77,3.19,0-1.31,0-3.88,0-4.09a17.36,17.36,0,0,0-3.52-8,5.39,5.39,0,0,0-.2-1,4.48,4.48,0,0,0-6-3c-3.48,1.49-4.85,8.17-4.54,11.53,0,.2.46,2.33.76,3.67-.3-.76-.58-1.5-.89-2.28-.61-1.55-1.27-3.07-2-4.71l-1.1-2.37c-.36-.8-.83-1.59-1.25-2.4-1-1.85-2.1-3.68-3.25-5.5,1.35-.54,6.12-2.52,7.89-4.34s3.5-4.59,3.1-7.23a4.47,4.47,0,0,0-5.44-3.84c-3.66.94-6,7.34-6.23,10.71,0,.21.11,2.64.21,4-.7-1.09-1.4-2.18-2.14-3.25-2.15-3.11-4.42-6.19-6.67-9.27-.7-.95-1.37-1.9-2.05-2.84.48-.19,6.2-2.42,8.18-4.45,1.76-1.81,3.5-4.6,3.1-7.24a4.47,4.47,0,0,0-5.44-3.84c-3.66.94-6,7.34-6.23,10.71,0,.25.17,3.76.26,4.64-1.5-2.08-3-4.17-4.34-6.3a77.64,77.64,0,0,1-5-8.9c.22-.09,6.2-2.39,8.23-4.47,1.76-1.81,3.5-4.6,3.1-7.24A4.47,4.47,0,0,0,44,193.7c-3.66.94-6,7.34-6.23,10.71,0,.22.12,2.89.22,4.16l-.21.05a58.1,58.1,0,0,1-3.35-9.72c-.48-1.83-.83-3.6-1.14-5.34,1.16-.31,6.44-1.81,8.47-3.48s4-4.19,3.87-6.85a4.47,4.47,0,0,0-5-4.42c-3.75.54-6.81,6.63-7.38,10,0,.18-.14,2.06-.2,3.43-.13-.79-.27-1.6-.38-2.35-.4-2.83-.6-5.45-.75-7.77-.08-1.32-.13-2.51-.16-3.63,1-.9,4.87-4.59,5.88-7s1.61-5.55.28-7.86A4.47,4.47,0,0,0,31.43,162c-3.08,2.2-3,9-1.95,12.23.09.28,2,4.47,2,4.42l.06-.05c0,1.08,0,2.23.07,3.49.11,2.33.25,5,.59,7.81a81.07,81.07,0,0,0,1.55,9.15A58.55,58.55,0,0,0,37,208.93a.54.54,0,0,1,0,.11c-.72-.84-2.82-3.12-3-3.28-2.55-2.21-8.79-5-12-3a4.46,4.46,0,0,0-1.05,6.57c1.61,2.13,4.82,2.84,7.34,2.84,2.85,0,8.47-2.55,8.91-2.75a80.81,80.81,0,0,0,5,9.32c1.08,1.75,2.22,3.48,3.39,5.2-.65-.71-1.24-1.33-1.33-1.41-2.55-2.21-8.79-5-12-3a4.48,4.48,0,0,0-1.05,6.58c1.61,2.13,4.82,2.83,7.35,2.83s7.39-2.07,8.66-2.64l1.35,2c2.19,3.13,4.39,6.25,6.45,9.38.73,1.1,1.4,2.21,2.08,3.32-.57-.63-1.06-1.15-1.15-1.22-2.55-2.21-8.78-5-12-3a4.48,4.48,0,0,0-1,6.58c1.61,2.13,4.82,2.83,7.35,2.83s6.92-1.87,8.43-2.54c.66,1.16,1.33,2.31,1.92,3.46.38.8.81,1.54,1.15,2.36s.71,1.6,1.06,2.39c.61,1.54,1.26,3.13,1.82,4.65.4,1.05.76,2.07,1.13,3.09-.72-1.11-2.15-3.24-2.29-3.41-2.19-2.57-7.93-6.25-11.43-4.8a4.48,4.48,0,0,0-2,6.34c1.27,2.35,4.34,3.54,6.83,3.92,2.74.42,8.46-1.16,9.17-1.36.6,1.69,1.17,3.34,1.68,4.9,1.77,5.37,3,9.91,3.89,13.11l2.54-.37c0-.07,0-.13-.06-.21-.93-3.23-2.33-7.82-4.25-13.25-.6-1.72-1.28-3.54-2-5.41a46,46,0,0,0,4.77-3.15c2.22,1.8,7.48,3.52,8.16,3.73-.43,1.74-.86,3.43-1.3,5-1.48,5.45-2.93,9.94-4,13.08l2.78-.4c1-3.11,2.15-7.23,3.37-12.11.44-1.77.88-3.66,1.32-5.61.72,0,6.65.38,9.25-.62,2.35-.9,5.1-2.71,5.84-5.27a4.47,4.47,0,0,0-3.33-5.77c-3.72-.68-8.55,4.14-10.15,7.11-.09.18-.9,2.2-1.39,3.48.18-.8.35-1.57.52-2.39.34-1.63.64-3.26,1-5,.13-.85.25-1.71.38-2.58s.19-1.79.29-2.69c.19-2.1.28-4.23.32-6.38,1.43.3,6.5,1.28,9,.74s5.45-1.91,6.57-4.33a4.48,4.48,0,0,0-2.42-6.21c-3.57-1.23-9.08,2.8-11.11,5.5-.12.17-1.36,2.27-2,3.44,0-1.3,0-2.59,0-3.89-.07-3.78-.27-7.6-.45-11.42,0-1.17-.09-2.33-.14-3.5.51.11,6.51,1.41,9.28.81,2.47-.54,5.46-1.91,6.58-4.33A4.48,4.48,0,0,0,98.4,210c-3.57-1.23-9.08,2.8-11.11,5.5-.15.2-1.92,3.23-2.34,4-.1-2.57-.17-5.13-.14-7.65a78.74,78.74,0,0,1,.72-10.2c.24,0,6.5,1.43,9.34.81,2.46-.53,5.45-1.9,6.57-4.32A4.47,4.47,0,0,0,99,192c-3.57-1.23-9.08,2.8-11.1,5.5-.14.17-1.49,2.48-2.11,3.59l-.2-.07a56.69,56.69,0,0,1,2.56-10c.61-1.79,1.29-3.46,2-5.08,1.14.38,6.37,2,9,1.77s5.63-1.29,7-3.58a4.47,4.47,0,0,0-1.72-6.43c-3.42-1.62-9.33,1.78-11.65,4.24-.12.13-1.25,1.63-2.05,2.74.32-.72.65-1.48,1-2.17,1.22-2.58,2.5-4.87,3.65-6.89.66-1.15,1.28-2.17,1.88-3.12,1.31-.21,6.58-1.14,8.74-2.56s4.4-3.75,4.57-6.41A4.48,4.48,0,0,0,106.07,158.61Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347,436.31l-.47-3.12c.16,0,15.46-2.41,22.78-9.45,1.57-1.51,1.53-2.6,1.36-3.29-1.69-7-27.57-18-79.11-33.55-8.49-2.56-16.71-5-24.59-7.34-51.46-15.28-85.46-25.37-87.81-36.82-.59-2.86.7-5.64,3.84-8.24,17.83-14.81,88.83-20.18,91.85-20.41l.23,3.16c-.73.05-73,5.51-90.06,19.68-3.27,2.71-2.89,4.57-2.76,5.17,2,9.6,38.88,20.56,85.61,34.43,7.88,2.34,16.11,4.78,24.6,7.34,68.85,20.77,79.75,29.5,81.28,35.84.54,2.23-.22,4.35-2.25,6.31C363.41,433.76,347.63,436.21,347,436.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,332.87l4.56,1C212.6,322,274.37,317.3,275,317.25l-.23-3.16C271.91,314.31,206.06,319.29,185.2,332.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.45,439.69a9.21,9.21,0,0,0-3.69-10.39c-4.6-3-13-6.7-27.17-7.71-25.13-1.8-42.19,7.48-50.27,15.25s-6.28,17.06,5.39,22.74,20.05,7.18,29.92,5.69,26-9.28,31.71-13.17,12.57-7.48,14.07-12.26Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.81,458.09c-14.06,9.57-27.53,5.08-27.53,5.08l-.31.26a41.89,41.89,0,0,0,20.66,1.84c9.87-1.5,26-9.28,31.71-13.17s12.57-7.48,14.07-12.26l0-.15a7.93,7.93,0,0,0,.27-1.17C346.87,440.67,329.26,449.61,316.81,458.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.17,441.63c0,2.15-2.62,3.89-5.84,3.89s-5.83-1.74-5.83-3.89,2.61-3.89,5.83-3.89S296.17,439.48,296.17,441.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.6,382.14l-.64-3.09c9.47-2,15.73-4.8,16.61-6.2-1-1-5-3.17-8.33-4.92-12.07-6.37-32.26-17-25.84-30.79,3.75-8.05,24.2-15.1,62.5-21.53,27.79-4.67,54.9-7.17,55.17-7.2l.29,3.15c-.27,0-27.28,2.52-55,7.17-48.09,8.08-58.33,15.84-60.15,19.75-5.15,11,12.67,20.43,24.46,26.66,7.16,3.78,10.42,5.5,10.08,7.9C197.12,377.81,184.15,381,178.6,382.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.07,308.41c-.27,0-27.38,2.53-55.17,7.2-25.67,4.31-43.3,8.9-53.28,13.88l5.24,1.13c8.66-3.54,23.44-7.67,48.55-11.89,27.67-4.65,54.68-7.14,55-7.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.78 404.69 219.59 437.25 11.24 364.99 74.59 342.15 276.78 404.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.9 388.15 191.7 390.24 198.81 386.53 192.09 384.52 184.9 388.15",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.35 379.48 168.46 383.1 182 387.26 189.16 383.64 174.69 379.31 174.35 379.48",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.56 391.12 201.8 393.34 209 389.58 201.7 387.39 194.56 391.12",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.36 376.93 154.9 378.94 161.61 375.39 155.6 373.59 148.36 376.93",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.75 379.81 165.78 382.28 171.95 378.49 164.48 376.25 157.75 379.81",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.31 399.33 183.16 397.07 176.06 400.78 183.12 403.09 190.31 399.33",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.67 394.22 213.81 397.03 221.12 393.21 211.9 390.45 204.67 394.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.86 371.56 137.11 373.48 144.05 370.13 137.64 368.21 130.86 371.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.5 406.36 205.02 403.99 197.63 407.85 205.43 410.41 212.5 406.36",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.04 401.46 214.01 399.3 207.66 402.61 214.98 404.93 221.04 401.46",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.67 397.91 223.55 400.02 230.52 396.02 224.02 394.08 216.67 397.91",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.18 403.09 193.15 400.23 185.91 404.01 194.83 406.93 202.18 403.09",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.54 399.32 233.3 396.86 226.31 400.87 234.42 403.36 241.54 399.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.89 404.79 223.8 402.3 217.71 405.8 225.67 408.31 231.89 404.79",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.94 371.07 140.07 374.39 145.34 376 152.55 372.68 147.05 371.03 146.94 371.07",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.07 365.87 54.96 363.29 51.34 362.11 45.15 364.55 49.07 365.87",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.75 359.69 57.86 362.02 63.96 359.35 56.74 357.07 50.75 359.69",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.67 355.78 66.89 358.07 72.19 355.75 64.88 353.5 59.67 355.78",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.97 371.49 75.73 370.1 69.16 372.65 73.92 374.26 79.97 371.49",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.81 366.19 57.97 364.28 52.04 366.88 57.84 368.83 63.81 366.19",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.94 359.03 73.04 360.01 78.11 357.56 75.28 356.69 69.94 359.03",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.57 369.07 66.8 367.18 60.8 369.83 66.04 371.6 72.57 369.07",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.03 368.85 127.93 370.66 134.68 367.32 128.91 365.6 122.03 368.85",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.38 363.73 110.24 365.23 116.58 361.9 111.77 360.46 105.38 363.73",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.59 362.4 85.87 359.94 81.07 358.47 75.97 360.94 80.59 362.4",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.1 366.1 119.04 367.93 125.89 364.69 119.46 362.77 113.1 366.1",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.38 358.01 96.61 361.04 102.5 362.85 108.85 359.59 103.47 357.98 103.38 358.01",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.76 358.32 93.55 360.1 100.37 357.05 94.26 355.22 87.76 358.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.24 355.4 84.78 357.41 91.25 354.32 84.98 352.44 78.24 355.4",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.54 388.65 173.2 391.71 179.28 388.63 169.07 385.5 163.54 388.65",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.07 392.62 182.96 394.8 189.04 391.63 182.19 389.52 176.07 392.62",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.14 398.42 202.01 395.61 195.79 398.86 204.82 401.72 211.14 398.42",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.8 395.69 192.95 397.96 199.14 394.73 191.91 392.51 185.8 395.69",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.82 374.39 82.92 372.46 76.84 375.25 82.74 377.24 88.82 374.39",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.73 379.53 141.79 381.77 146.9 378.69 140.03 376.58 134.73 379.53",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.47 382.62 151.34 384.79 156.61 381.67 149.61 379.52 144.47 382.62",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.04 385.64 160.81 387.79 166.31 384.65 159.33 382.5 154.04 385.64",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.19 366.07 80.73 364.66 74.59 367.51 79.32 369.06 85.19 366.07",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.15 354.45 81.86 351.51 71.59 348.43 71.61 348.49 64.09 351.05 75.15 354.45",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.65 350 68.21 347.42 66.05 346.77 58.74 349.41 60.65 350",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.37 402.46 269.7 405.56 272.38 404.03 262.2 400.92 259.37 402.46",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.76 363.71 73.2 362.27 67.31 365.12 71.66 366.55 77.76 363.71",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126 376.77 131.97 378.66 137.24 375.72 131.25 373.88 126 376.77",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.86 363.01 64.42 364.18 70.28 361.35 67.01 360.31 60.86 363.01",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.67 373.82 123.23 375.89 128.45 373.02 121.75 370.96 116.67 373.82",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.4 374.36 105.52 372.5 99.37 375.64 105.54 377.66 111.4 374.36",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.68 377.3 114.16 375.23 108.26 378.55 114.62 380.63 120.68 377.3",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.39 383.22 132.2 380.94 126.03 384.38 133.44 386.8 139.39 383.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.32 396.17 173.39 393.98 166.28 397.57 173.26 399.86 180.32 396.17",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.91 386.23 142.06 384.07 136.08 387.67 142.78 389.87 148.91 386.23",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.51 393.07 151.61 387.09 145.44 390.74 163.45 396.64 170.51 393.07",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.44 380.07 123.45 378.18 117.36 381.53 123.31 383.48 129.44 380.07",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.13 368.58 105.33 370.23 110.61 367.54 105.41 365.95 100.13 368.58",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.72 365.61 97.25 367.67 102.49 365.05 95.83 363 90.72 365.61",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.66 371.6 97.41 369.93 91.16 372.94 96.55 374.71 102.66 371.6",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.2 371.14 113.92 372.95 118.96 370.11 113.5 368.43 108.2 371.14",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.56 363.34 87.86 364.7 92.93 362.12 88.88 360.87 83.56 363.34",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.48 369.01 88.05 366.97 82.14 369.99 88.28 372 94.48 369.01",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.75 358.71 53.7 356.1 46.52 353.83 40.02 356.18 47.75 358.71",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.58 387.52 74.04 376.53 74.01 376.54 74 376.51 57.95 371.09 47.28 375.81 96.46 392.82 106.58 387.52",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.65 369.03 37.84 364.31 33.14 362.72 22.09 367.1 27.65 369.03",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.2 367.13 40.74 365.29 30.52 370.02 35.6 371.77 46.2 367.13",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.99 370.1 49.17 368.13 38.54 372.79 44.36 374.8 54.99 370.1",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.19 396.84 128.14 394.8 117.6 400.13 124.2 402.41 134.19 396.84",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.31 390.46 109.34 388.45 99.19 393.76 104.81 395.71 115.31 390.46",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.34 393.85 118.12 391.41 107.6 396.67 114.82 399.17 125.34 393.85",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.02 353.55 100.18 351.37 92.68 349.07 87.97 351.13 96.02 353.55",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.91 354.41 103.36 355.75 108.13 353.8 103.05 352.24 98.91 354.41",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.5 402.69 136.89 397.75 126.87 403.34 140.74 408.13 151.5 402.69",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.58 356.71 111.63 358.22 116.14 356.25 111.31 354.77 106.58 356.71",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.08 360.47 33.13 360.45 33.15 360.5 42.06 363.51 48.21 361.08 36.8 357.34 30.52 359.61 33.08 360.47",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.02 348.45 84.85 350.2 89.59 348.13 83.96 346.4 79.02 348.45",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.79 352.55 55.45 350.6 49.78 352.65 56.62 354.82 61.79 352.55",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.84 418.99 216.13 416.13 209.33 419.99 217.8 422.85 224.84 418.99",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.78 403.89 249.37 407.95 259.83 411.16 267.16 407 256.78 403.89",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.82 347.5 80.79 345.44 74.81 343.61 69.38 345.57 75.82 347.5",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.79 409.36 240.27 412.94 250.84 416.28 257.31 412.6 246.79 409.36",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.01 425.14 207.14 431.1 218.1 434.88 228.82 428.79 218.01 425.14",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.72 414.34 230.12 418.5 240.78 422 248.34 417.7 237.72 414.34",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.54 361.66 27.33 360.76 15.79 364.93 19.04 366.05 30.54 361.66",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.29 424.22 206.87 421.38 196.32 427.35 204.45 430.17 215.29 424.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.75 413.24 173.94 410.26 163.16 415.88 171.89 418.9 182.75 413.24",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.19 420.48 196.59 417.91 196.39 418.02 196.27 417.8 185.51 414.17 174.63 419.85 193.67 426.44 204.19 420.48",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.17 409.33 164.19 406.97 153.5 412.55 160.42 414.94 171.17 409.33",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.3 423.4 227.59 419.89 220.52 423.76 231.27 427.4 238.3 423.4",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.75 359.15 119.29 360.51 123.71 358.56 119.23 357.19 114.75 359.15",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.43 406.04 154.31 403.63 143.51 409.09 150.76 411.6 161.43 406.04",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.54 374.96 174.48 377.04 178.06 375.18 171.73 373.25 167.54 374.96",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.97 411.82 195.02 409.21 188.1 412.82 196.36 415.61 202.97 411.82",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.51 404.45 173.45 402.14 166.78 405.62 173.76 407.98 180.51 404.45",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.94 403.04 244.34 400.16 237.19 404.21 246.56 407.09 253.94 403.04",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.43 415.25 205.67 412.7 199.03 416.51 206.65 419.08 213.43 415.25",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.98 408.5 234.67 405.64 228.41 409.18 237.49 412.06 243.98 408.5",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.16 409.73 215.23 407.22 208.13 411.29 215.91 413.84 223.16 409.73",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.94 413.46 225.91 410.6 218.62 414.73 227.38 417.6 234.94 413.46",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.22 408.29 183.3 405.37 176.52 408.91 185.34 411.88 192.22 408.29",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.15 383.03 108.77 380.94 102.55 383.93 109.16 386.16 115.15 383.03",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.23 386 117.94 383.94 111.92 387.1 117.96 389.13 124.23 386",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.88 379.99 100.5 378.22 94.66 381.27 99.69 382.97 105.88 379.99",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.79 397.99 137.15 390.24 130.78 393.46 154.14 401.35 160.79 397.99",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.65 401.22 163.62 398.92 156.94 402.3 164.01 404.69 170.65 401.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.32 389.31 127.07 386.94 120.78 390.08 127.98 392.52 134.32 389.31",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.62 366.9 146.94 368.8 151.31 367 144.9 365.04 140.62 366.9",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.15 369.76 155.47 371.35 159.67 369.56 154.49 367.97 150.15 369.76",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.63 372.3 164.34 374 168.55 372.27 162.81 370.52 158.63 372.3",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.38 377.91 183.16 379.64 183.15 379.63 186.87 377.88 180.93 376.06 177.38 377.91",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.7 377.31 91.75 375.35 85.63 378.22 91.89 380.33 97.7 377.31",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.71 364.23 137.49 365.96 141.8 364.09 135.77 362.25 131.71 364.23",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.4 361.44 128.74 363.34 132.82 361.35 126.79 359.5 122.4 361.44",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.7 392.68 233.04 394.58 235.98 392.9 229.86 391.03 226.7 392.68",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.58 389.05 223.8 391.81 226.99 390.15 217.84 387.35 214.58 389.05",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.38 400.06 249.74 397.11 246.88 398.72 256.54 401.62 259.38 400.06",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.82 395.41 244.08 397.88 246.96 396.26 238.74 393.74 235.82 395.41",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.17 380.54 191.9 382.26 195.55 380.53 189.87 378.8 186.17 380.54",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.92 383.16 201.49 385.13 204.85 383.38 198.55 381.45 194.92 383.16",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.38 386 211.68 388.18 214.97 386.47 207.72 384.25 204.38 386",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.59 437.25 219.11 443.72 276.18 411.92 276.78 404.69 219.59 437.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.48 416.13 268.48 423.97 275.79 420.02 276.18 411.92 268.48 416.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.48 423.97 258.41 422 268.68 416.13 268.48 423.97",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.11 443.72 11.2 370.64 11.24 364.99 219.59 437.25 219.11 443.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-159"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "266.21 323.65 205.75 345.45 316.11 373.55 377.7 347.48 266.21 323.65",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.75 345.45 205.75 348.88 315.93 378.06 316.11 373.55 205.75 345.45",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.11 373.55 377.7 347.48 377.25 351.25 315.93 378.06 316.11 373.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.33 296.45 270.84 335.01 267.36 336.51 330.3 351.43 333.78 349.94 336.52 308.14 273.33 296.45",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.85 297.95 267.36 336.51 330.3 351.43 333.04 309.64 269.85 297.95",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.85,54.81l-3.76-1.43-5.27.33-.43,1.44L173.48,72.64a3.29,3.29,0,0,0-3.08,2.93L151,276.47a2.67,2.67,0,0,0,2.14,2.89l274.08,52.51-3,1.83,12.15,2.36,1.41-.19,3.43-1.66a3,3,0,0,0,2.14-2.47L478.86,58A3,3,0,0,0,476.85,54.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.64,73.64,147,278.12a2.65,2.65,0,0,0,2.14,2.89L435.8,335.94a3,3,0,0,0,3.51-2.54L474.88,56.54a3,3,0,0,0-3.12-3.35l-300,17.52A3.28,3.28,0,0,0,168.64,73.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.23 79.81 157.01 249.42 431.27 291.49 462.17 63.91 175.23 79.81",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.43,192.22c43.89-13.44,93-28.24,138.46-41.36,46-13.29,83-18.29,108.91-19.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.77,105.18s88.63,2,185.43,41.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,263.46s67.28-63.14,131-96.38c53.68-28,76.8-28.67,76.8-28.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.14,281,435.8,335.94a3,3,0,0,0,3.51-2.54l3.45-26.9L149.05,258.68,147,278.12A2.65,2.65,0,0,0,149.14,281Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.01 249.42 198.4 255.76 207.14 176.65 165.15 173.64 157.01 249.42",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.55 201.2 193.76 200.19 190.44 226.19 199.65 227.38 202.55 201.2",
    style: {
      fill: "#babdbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,198.45a.48.48,0,0,1-.07.18l13.72,1.58,2.22-20.13-13.28-1Z",
    style: {
      fill: "#babdbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.45 226.06 192.77 200.08 179.65 198.57 176.45 224.38 189.45 226.06",
    style: {
      fill: "#babdbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.21 227.43 176.32 225.37 173.46 248.47 189.45 250.92 192.21 227.43",
    style: {
      fill: "#babdbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,198.53a.5.5,0,0,1,0-.21l2.58-19.26-8.45-.61-2.37,19.13Z",
    style: {
      fill: "#babdbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.2 227.56 190.44 251.07 196.93 252.07 199.54 228.38 193.2 227.56",
    style: {
      fill: "#babdbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopApp);
export default __webpack_public_path__ + "static/media/DesktopApp.6c25d26c4026b2f9972cf7938fdf9b71.svg";
export { ForwardRef as ReactComponent };